<script setup lang="ts">
const TRADEMARKS = [
  'DO WHAT’S NATURAL',
  'POSTPLAY',
  'LOCKING LIPS DESIGN',
  'POWER C BRIGHTENING SERUM',
  'GOODFORM',
  'GROVE COLLABORATIVE',
  'LINIA',
  'ROVEN',
  'SEEDLING',
  'GOODFORM',
  'GROVE COLLABORATIVE',
  'HONU',
  'LINIA',
  'ROOT 7 COMPLEX',
  'ROOT 7 NUTRIENTS',
  'ROOT FOR WOMEN',
  'ROOTED BEAUTY',
  'ROVEN',
  'ROVEN BEAUTY',
  'SEEDLING BY GROVE',
  'THIS PRODUCT HELPS WOMEN DISCOVER HOW! Design',
  'SUSTAIN NATURAL',
  'TEN PERCENT FOR WOMEN A REPRODUCTIVE HEALTH INITIATIVE 10% 4 DESIGN',
]
</script>

<template>
  <section class="TheTrademarks">
    <h2 class="TheTrademarks_Heading">Trademarks</h2>
    <ul class="TheTrademarks_BulletPoints">
      <li v-for="(trademark, index) in TRADEMARKS" :key="index">
        {{ trademark }}
      </li>
    </ul>
  </section>
</template>

<style lang="scss">
.TheTrademarks {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
  }

  &_BulletPoints {
    margin: 0;
    display: grid;
    row-gap: var(--spacing-2x);
  }
}
</style>
